export const METRIC_CARD_MIN_HEIGHT = '280px';
